//import React from 'react';
import cmsUtils from '../../../cms/utils/cmsUtils';
import utils from '../../../utils';
import { SiteLink } from '../../../components';

/** @jsx jsx */
import { jsx } from '@emotion/core'
import style from './style';

export function PageTilesBsyc(props) {
  const item = props.item;
  //const detailHoverBgColor = props.detailHoverBgColor ? props.detailHoverBgColor : "black";
  const cmsOption = props.cmsOption || {};
  const pages = getPages(cmsUtils.payload(item, 'PageObjects'))
  const pageTileElts = pages.map((page, index) =>
    <Tile page={page} key={index} disableLink={cmsOption.isCmsEdit} idx = {index}></Tile>
  );

  //const cssClass = utils.classNames('cms_item', 'pageTiles tiles', item.cssClass || item.anchorName || '');
  const cssClass = utils.classNames('cms_item', 'pageTiles__bsyc', item.cssClass || item.anchorName || '');

  return (
    <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}
     css = {style.pageTiles}>
      {pageTileElts}
    </div>
  );
}

function getPages(pagesSerialized) {
  if (pagesSerialized) {
    return JSON.parse(pagesSerialized);
  }
  return [];
}

function Tile(props) {
  const page = props.page;
  const imageUrl = utils.site.resourcePath(page.imageUrl);
  //const imageUrl = 'https://cafedevilis.stg5.jaba.com.au/sites/cafedevilis/media/images/foodplate.png';
  const disableLink = props.disableLink;
  const colorTheme = page.colorTheme;
  const index = props.idx;
  //page.tileButtonText
  //console.log("page", page);


  //

  return (
    
    <div css = {style.pageTile__tile} className="pageTile__bsyc">
      <SiteLink className="pageTile__bsyc__content" css = {style.tile__content} to={disableLink ? '' : page.pageUrl}>
      <div css={style.tile__flip__wrapper}>

        <div className="pageTile__bsyc__bg" data-aos={index % 2 === 0 ? 'fade-up-right' : 'fade-up-left'} css = {style.tile__bg}>
          {/* <div className="pageTile__bsyc__bg2" css = {style.tile__bg2} style={{ backgroundImage: utils.css.bgUrlStyle(imageUrl) }}></div> */}
          
          <div className={`pageTile__bsyc__bg2 ${index % 2 === 0 ? 'odd' : 'even'}`} css = {style.tile__bg2}>
            <div className={`img__container ${index % 2 === 0 ? 'odd' : 'even'}`} css={style.img__container}>
              <img src={imageUrl} style={{width:'100%'}} alt='tile-1' />
            </div>
          </div>

        </div>
        
        <div css = {style.tile__details} className={`pageTile__bsyc__content__details ${colorTheme}`} data-aos={index % 2 === 0 ? 'fade-up-left' : 'fade-up-right'}>  
          <div className="pageTile__bsyc__container">
            
            {
              (page.pageTitle && page.pageTitle !== '') &&
              <div className={`pageTile__bsyc__title ${index % 2 === 0 ? 'odd' : 'even'}`}>
                {page.pageTitle}
              </div>
            }

            {
              (page.tileButtonText && page.tileButtonText !== '') &&
              <div className={`pageTile__bsyc__short__des ${index % 2 === 0 ? 'odd' : 'even'}`}>
                {page.tileButtonText}
              </div>
            }

            <div className={`pageTile__bsyc__desc ${index % 2 === 0 ? 'odd' : 'even'}`}>
              {page.tileDesc || page.description}
            </div>

          </div>
        </div>
        </div>
      </SiteLink>
    </div>
  )
}